const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewCompassEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(250, 2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45) scale(0.7, 0.7)",
    style: {}
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 3
    },
    points: "250 50 213 213 250 250"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 3
    },
    points: "250 50 287 213 250 250"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 3
    },
    points: "250 450 213 287 250 250"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 3
    },
    points: "250 450 287 287 250 250"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 3
    },
    points: "50 250 213 213 250 250"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 3
    },
    points: "50 250 213 287 250 250"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 3
    },
    points: "450 250 287 287 250 250"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 3
    },
    points: "450 250 287 213 250 250"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 3
    },
    points: "250 50 213 213 250 250"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 3
    },
    points: "250 50 287 213 250 250"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 3
    },
    points: "250 450 213 287 250 250"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 3
    },
    points: "250 450 287 287 250 250"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 3
    },
    points: "50 250 213 213 250 250"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 3
    },
    points: "50 250 213 287 250 250"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 3
    },
    points: "450 250 287 287 250 250"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 3
    },
    points: "450 250 287 213 250 250"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(0, 0, 0)",
      fontSize: 52,
      fontFamily: "Oldenburg"
    },
    x: 235.539,
    y: 37.44
  }, "\n\t\tN\n\t"), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(0, 0, 0)",
      fontSize: 52,
      fontFamily: "Oldenburg"
    },
    x: 239.88,
    y: 496.877
  }, "\n\t\tS\n\t"), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(0, 0, 0)",
      fontSize: 52,
      fontFamily: "Oldenburg"
    },
    x: 0,
    y: 267.659
  }, "\n\t\tW\n\t"), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(0, 0, 0)",
      fontFamily: "Arial, sans-serif",
      fontSize: 52
    },
    x: 465.313,
    y: 267.937
  }, "\n\t\tE\n\t"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCompassEn);
export default __webpack_public_path__ + "static/media/new_compass_en.ace68c915d4d0af4495b33194a6bd5f5.svg";
export { ForwardRef as ReactComponent };